import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

export const AssessmentLayout = ({ children }) => (
  <>
    <CssBaseline />
    <Container component="main">{children}</Container>
  </>
);

AssessmentLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
